export default __webpack_public_path__ + "static/media/ReconIcon.e3bcbbaf.svg";